import { Route, Routes } from 'react-router-dom'

import GroupEdit from './GroupEdit'
import GroupList from './GroupList'
import GroupNew from './GroupNew'
import TabContent from './TabContent'

export default function GroupConfig() {
  const readerHelpIconProps = {
    builderPath: '/builder/ja-JP/ocr-reader-doc/group-settings.html#Group',
    concurPath: '/concur/ja-JP/ocr-reader-doc/group-settings.html#Group',
    invoicePath: '/invoice/ja-JP/ocr-reader-doc/group-settings.html#Group',
    orderFormPath: '/order-form/ja-JP/ocr-reader-doc/group-settings.html#Group',
  }

  return (
    <TabContent
      padding
      title="グループ設定"
      readerHelpIconProps={readerHelpIconProps}
      description="ユーザーグループの作成・編集・削除が可能です"
    >
      <Routes>
        <Route errorElement={<div />}>
          <Route index element={<GroupList />} />
          <Route path="new" element={<GroupNew />} />
          <Route path=":name" element={<GroupEdit />} />
        </Route>
      </Routes>
    </TabContent>
  )
}
